ixModuleRouting("impactx.deliveryadvice", {
    "/deliveryadvicesupplierlist": {
        template: "<ixa-delivery-advice-supplier-list></ixa-delivery-advice-supplier-list>",
        templateUrl:
            "modules/deliveryadvice/templates/deliveryadvicesupplierlist.html",
        process: "ListDeliveryAdviceSupplier",
        controller: "DeliveryAdviceSupplierListCtrl",
        controllerAs: "deliveryAdviceSupplierListCtrl",
        workspace: "shop",
    },
    "/deliveryadvicebuyerlist": {
        template: "<ixa-delivery-advice-buyer-list></ixa-delivery-advice-buyer-list>",
        templateUrl:
            "modules/deliveryadvice/templates/deliveryadvicebuyerlist.html",
        process: "ListDeliveryAdviceBuyer",
        controller: "DeliveryAdviceBuyerListCtrl",
        controllerAs: "deliveryAdviceBuyerListCtrl",
        workspace: "shop",
    },
    "/deliveryadvicebuyer/:pohid/:avhid?": {
        template: "<ixa-delivery-advice-buyer-detail></ixa-delivery-advice-buyer-detail>",
        templateUrl: "modules/deliveryadvice/templates/deliveryadvice.html",
        process: "ViewDeliveryAdviceBuyer",
        controller: "DeliveryAdviceBuyerCtrl",
        controllerAs: "deliveryAdviceCtrl",
        workspace: "shop",
    },
    "/deliveryadvicesupplier/:pohid/:avhid?": {
        template: "<ixa-delivery-advice-supplier-detail></ixa-delivery-advice-supplier-detail>",
        templateUrl: "modules/deliveryadvice/templates/deliveryadvice.html",
        process: "ViewDeliveryAdviceSupplier",
        controller: "DeliveryAdviceSupplierCtrl",
        controllerAs: "deliveryAdviceCtrl",
        workspace: "shop",
    },
});